'use client';

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ style, ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const t = useTranslations();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          // The --color-* tokens: --popover and --border are bare HSL triplets.
          '--normal-bg': 'var(--color-popover)',
          '--normal-text': 'var(--color-popover-foreground)',
          '--normal-border': 'var(--color-border)',
          '--border-radius': 'var(--radius)',
          // Sonner sets its own font stack, which starts with system-ui.
          fontFamily: 'inherit',
          // Merged, not replaced: the app layout passes its own position.
          ...style,
        } as React.CSSProperties
      }
      {...props}
      containerAriaLabel={t('common.toaster.notifications')}
    />
  );
};

export { Toaster };
